import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { SectionReveal } from '../components/SectionReveal';
export function FinalCTASection() {
  return <section className="relative w-full bg-brand-dark py-20 md:py-28 overflow-hidden" data-id="element-95">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-blue-500/30 to-transparent" data-id="element-96" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center" data-id="element-97">
        <SectionReveal data-id="element-98">
          <p className="text-4xl mb-4" data-id="element-99">🚀</p>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl md:text-4xl text-white mb-4 uppercase leading-tight tracking-[-0.02em]" data-id="element-100">
            No sigas perdiendo plata todos los meses.
          </h2>
          <p className="text-xl sm:text-2xl text-blue-400 font-body font-bold mb-2" data-id="element-101">
            Empezá a pagar lo que realmente corresponde.
          </p>
          <p className="text-lg sm:text-xl font-body font-bold mb-10" data-id="element-102">
            <span style={{
            color: '#00C853'
          }} data-id="element-103">
              Con garantía de 15 días
            </span>
            <span className="text-gray-300" data-id="element-104">
              {' '}
              — sin ningún riesgo para vos.
            </span>
          </p>
        </SectionReveal>

        <SectionReveal delay={0.15} data-id="element-105">
          <CTAButton text="QUIERO EMPEZAR A AHORRAR HOY" size="xl" data-id="element-106" />
        </SectionReveal>
      </div>

      {/* Footer */}
      <div className="relative z-10 max-w-3xl mx-auto px-4 mt-20 pt-8 border-t border-gray-800" data-id="element-107">
        <p className="text-center text-gray-600 font-body text-sm" data-id="element-108">
          © {new Date().getFullYear()} Ahorro Total · Todos los derechos
          reservados
        </p>
      </div>
    </section>;
}